// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"8385e014","360":"d1c4229b","938":"53af600c"}[chunkId] + ".chunk.css";
};